
import { Stack, LinearProgress } from "@mui/material"

export const DoktorLinearBar = ({value}) => {

    return (
        <Stack marginTop={2}>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: '10px', // Adjust height as desired
                    borderRadius: 4,
                    '& .MuiLinearProgress-barColorPrimary': {
                        background: "linear-gradient(0deg, rgba(217, 217, 217, 0.25), rgba(217, 217, 217, 0.25)), linear-gradient(0deg, #0AECBA, #0AECBA); ", // Adjust gradient colors
                    },
                }}
            />
        </Stack>
    )

} 